import React from 'react';
import alertIcon from '../../../../assets/images/alert.svg';

/* Alert depicting Attention*/
const AttentionAlert = ({ title, description, classes = '' }) => {
  return (
    <div className={'rounded-ds-sm bg-ds-amber-100 p-4 border border-ds-amber mt-2 ' + classes}>
      <div className='flex'>
        <div className='flex-shrink-0'>
          <img className='mt-1' src={alertIcon} alt='alert icon' />
        </div>
        <div className='ml-3'>
          <h3 className='text-ts-md mb-0 font-semibold text-ds-amber-500'>
            {title}
          </h3>
          <div className='text-xs text-ds-amber-500'>
            {description}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttentionAlert;
